export default {
  state: {
    api_root: process.env.VUE_APP_API_ENDPOINT,
  },
  getters: {
    api_root_url: (state) => state.api_root,
    api_cached_root_url: (state) =>
      state.api_root.replace('/api', '/cached/api'),
    login_url: (state, getters) => `${state.api_root}/login`,
    register_web_user_url: (state, getters) => {
      if (getters.domainBasedBrand) {
        return `${state.api_root}/${getters.domainBasedBrand}/register_web_user`
      } else {
        return `${state.api_root}/register_web_user`
      }
    },
    logout_url: (state, getters) => `${state.api_root}/logout`,
    refresh_token_url: (state, getters) => `${state.api_root}/refresh`,
    reset_pass_url: (state, getters) =>
      `${state.api_root}/reset_password_web_user`,
    forgot_pass_url: (state, getters) =>
      `${state.api_root}/forgot_password_web_user`,
    logging_url: (state, getters) => `${state.api_root}/logging`,
    send_otp_url: (state) =>
      `${state.api_root}/public/model/verification/generate`,
    confirm_otp_url: (state) =>
      `${state.api_root}/public/model/verification/confirm`,
    customerAPI: (state, getters) =>
      `${state.api_root}/` +
      (getters.domainBasedBrand
        ? `${getters.currentBrandId}/model/brand_customers/id/`
        : 'model/goorder_customers/id/'),
    save_card_api_url: (state, getters) =>
      `${state.api_root}/` +
      (getters.domainBasedBrand
        ? `${getters.currentBrandId}/model/brand_customers/`
        : 'model/goorder_customers/') +
      `id/${getters.web_user.id}/save_card`,
    delete_card_api_url: (state, getters) =>
      `${state.api_root}/` +
      (getters.domainBasedBrand
        ? `${getters.currentBrandId}/model/customer_cards/`
        : 'model/go_customer_cards/'),
    order_update_request_url: (state, getters) =>
      `${getters.store_api_base}/model/orders/id/${getters.order_id}/update_order_items`,
    order_post_request_url: (state, getters) =>
      `${state.api_root}/{brand_id}/{store_id}/model/orders/add`,
    brand_api_base: (state, getters) =>
      `${state.api_root}/${getters.currentBrandId}`,
    customization_update_post_request_url: (state, getters) =>
      `${getters.brand_api_base}/model/brands/id/${getters.currentBrandId}/change_brand_website_customization_action_id`,
    get_single_order_api_url: (state, getters) =>
      `${getters.brand_api_base}/model/orders/id/`,
    dinein_reservation_request_url: (state, getters) =>
      `${getters.store_api_base}/model/reservations/add`,
    dine_in_table_area: (state, getters) =>
      `${getters.store_api_base}/model/dine_in_tables?byColumn=1&item_status=true&no_limit=true&lookups_needed=true&no_limit=true&min_max_needed=0`,
    dine_in_covers: (state, getters) =>
      `${getters.brand_api_base}/model/brand_dine_in_covers?page_id=brand_dine_in_covers_main_tbl&query=&limit=10&ascending=1&page=1&byColumn=0&orderBy=priority`,
    notify_store_dine_in: (state, getters) =>
      `${getters.store_api_base}/model/stores/socket_notification`,
    contact_us_api_url: (state) => `${state.api_root}/contact_us`,
    get_single_order_tracking_url: (state, getters) =>
      `${getters.brand_api_base}/${getters.currentStoreId}/model/orders/get_delivery_status?byColumn=1&no_limit=true&lookups_needed=0&min_max_needed=0&order_id=`,
    find_coupon_code_url: (state, getters) => (couponCode) =>
      `${getters.brand_api_base}/${getters.currentStoreId}/model/brand_order_discounts?limit=1&byColumn=1&page_id=brand_order_discounts_main_tbl&manual=true&online=true&coupon_code=${couponCode}` +
      (getters.domainBasedBrand ? '' : '&available_goorder=true'),
    store_api_base: (state, getters) =>
      `${getters.brand_api_base}/${getters.currentStoreId}`,
  },
}
